/* eslint-disable */
// VENDORED (V5 changes marked) from learning_brain_poc/rhs4_qturns.js (W7b / F3, POC commit 6ad5075e). Side-effect module: sets a window global.
// Chat v4 right-hand side, Questions tab, 'Why these questions': the question score table FOR EACH TURN.
// The server sends only the current plan().question_table, so the client keeps a short history (one entry per new plan, capped)
// and shows any turn read-only: the ranked table, what was asked and why, and what changed since the turn before.
// window.Rhs4QTurns = {record(snap), reset(), has(), render(deps), load(turns)};
// V5: load(turns) takes tse:diag_state `turns` (server/app/diagnosis/da_turns.py) as the history, so a reload or a revived session
// shows every turn; each V5 turn also carries what was answered and the cause % before / after (turnBreakdown).
// snap = {plan, table, k1, k2, taught, asked: [keys], open, observed}; deps = {h, cleanLabel, keyText, muted, section, plural, num2,
// scoreCell, formulaCard, k2Ramp, originText, rows, rerender}.
(function () {
  'use strict';

  const MAX_TURNS = 30;            // a long chat keeps only the latest turns, so the history never grows without bound
  const FLASH_CLASS = 'v4-flash', PANEL_ID = 'v4-qt-panel', TAB_PREFIX = 'v4-qt-tab-';
  const DROP_ANSWERED = 'answered', DROP_WAITING = 'waits for an earlier answer', DROP_GONE = 'dropped: already answered or it no longer tells the open causes apart';

  let hist = [], count = 0, lastPlan = null, prevObserved = 0, selected = null, showAll = false, flashed = 0, focusAfter = false;

  const ranked = t => t.filter(r => r.rank).sort((a, b) => a.rank - b.rank);
  const sigOf = s => JSON.stringify([s.k1, s.k2, s.asked, s.table.map(r => [r.key, r.rank, r.likelihood])]);

  function reset() { hist = []; count = 0; lastPlan = null; prevObserved = 0; selected = null; flashed = 0; showAll = false; }
  function record(s) {
    if (prevObserved && !s.observed) reset();   // the chat was emptied without a reset call: start the history again
    prevObserved = s.observed;
    if (!Array.isArray(s.table) || !s.table.length) return;
    const asked = [...new Set(s.asked || [])];
    if (s.plan === lastPlan) {                 // same plan re-rendered (tab switch, hotline click): only the asked set may have grown
      const top = hist[hist.length - 1];
      if (top) top.asked = [...new Set([...top.asked, ...asked])];
      return;
    }
    lastPlan = s.plan;
    const entry = {table: s.table.map(r => Object.assign({}, r)), k1: Number(s.k1), k2: Number(s.k2), taught: Number(s.taught || 0), asked,
      open: Number((s.table.find(r => r.n_open) || {}).n_open || s.open || 0)};
    entry.sig = sigOf(entry);
    entry.observed = s.observed;
    const top = hist[hist.length - 1];
    if (top && top.sig === entry.sig) return;
    // a rescore (hotline click, K1/K2 change) brings a new plan with no new answer and the same questions asked:
    // it replaces the live turn instead of adding a 'Turn n' chip; only a new answer or a new asked set is a new turn
    const sameAsked = top && top.asked.length === asked.length && asked.every(k => top.asked.includes(k));
    if (top && top.observed === entry.observed && sameAsked) { entry.n = top.n; hist[hist.length - 1] = entry; return; }
    entry.n = ++count;
    hist.push(entry);
    if (hist.length > MAX_TURNS) hist.shift();
  }
  const has = () => hist.length > 0;
  // V5: the server's turn list replaces the browser-kept history (same entry shape, plus the answers and cause moves)
  function load(turns) {
    hist = (Array.isArray(turns) ? turns : []).map(t => {
      const qs = t.question_scores || {};
      return {n: Number(t.turn) || 0, table: Array.isArray(qs.table) ? qs.table.map(r => Object.assign({}, r)) : [],
        k1: Number(qs.k1 || 0), k2: Number(qs.k2 || 0), taught: Number(qs.taught_cases || 0), asked: [...new Set(t.asked_keys || [])],
        open: Number(t.open || 0), observed: Number(t.observed || 0),
        v5: {answers: t.answers || [], causes: t.causes || [], ruled: t.ruled_out || [], scored: Array.isArray(qs.table) && qs.table.length > 0}};
    }).filter(t => t.n > 0);
    count = hist.length ? hist[hist.length - 1].n : 0;
    if (selected !== null && !hist.some(t => t.n === selected)) selected = null;
  }

  // ---------- V5: what one turn answered and how the causes moved ----------
  const MOVE_EPS = 0.05, RULED_STATUS = new Set(['ruled_out', 'failed']);
  const pctText = v => (v === null || v === undefined ? '·' : Math.round(Number(v)) + '%');
  function causeRow(c, ruled, d) {
    const hasBefore = c.before !== null && c.before !== undefined;
    const delta = hasBefore ? Number(c.after) - Number(c.before) : null;
    const still = delta !== null && Math.abs(delta) < MOVE_EPS;
    const cls = delta === null || still ? 'v4-muted' : delta > 0 ? 'v4-up' : 'v4-down';
    const moved = delta === null ? 'first turn' : still ? '·' : (delta > 0 ? '▲ ' : '▼ ') + Math.abs(Math.round(delta)) + ' pts';
    const out = ruled.has(c.cause_key), earlier = !out && RULED_STATUS.has(c.status);
    return d.h('tr', {class: out || earlier ? 'v4-qt-ruled' : null, title: earlier ? 'Ruled out in an earlier turn' : null},
      d.h('th', {scope: 'row', class: 'v4-rowh'}, d.cleanLabel(c.name) || 'A possible cause', out ? d.h('span', {class: 'v4-tag v4-qt-out'}, 'Ruled out') : null),
      d.h('td', null, pctText(c.before)), d.h('td', null, pctText(c.after)), d.h('td', {class: cls}, moved));
  }
  function turnBreakdown(t, d) {
    if (!t.v5) return null;
    const ruled = new Set(t.v5.ruled);
    const answers = t.v5.answers.length
      ? d.h('ul', {class: 'v4-qt-answers'}, t.v5.answers.map(a => d.h('li', null,
          d.h('span', {class: 'v4-qt-q'}, d.cleanLabel(a.question) || 'A question'), d.h('span', {class: 'v4-qt-a'}, d.cleanLabel(a.answer) || 'No answer given'))))
      : d.muted(t.n === 1 ? 'The problem as described; no question answered yet.' : 'No answer in this turn; the plan was refreshed.');
    const rows = t.v5.causes.slice().sort((a, b) => Number(b.after) - Number(a.after)).map(c => causeRow(c, ruled, d));
    const causes = rows.length
      ? d.h('div', {class: 'v4-scroll'}, d.h('table', {class: 'v4-matrix v4-qt-causes'},
          d.h('thead', null, d.h('tr', null, ['Cause', 'Before', 'After', 'Change'].map((x, i) => d.h('th', {scope: 'col', class: i === 0 ? 'v4-rowh' : ''}, x)))),
          d.h('tbody', null, rows)))
      : d.muted('No cause scored yet.');
    return d.h('div', {class: 'v4-qt-break'},
      d.h('div', {class: 'v4-label'}, 'Answered in this turn'), answers,
      d.h('div', {class: 'v4-label'}, 'Cause % before and after'), causes,
      ruled.size ? d.muted(d.plural(ruled.size, 'cause') + ' ruled out in this turn.') : null);
  }

  // ---------- what one turn says ----------
  const askedSet = t => new Set([...t.asked, ...t.table.filter(r => r.status === 'next').map(r => r.key)]);
  const label = (r, d) => d.cleanLabel(r.hint) || d.keyText(r.key) || 'A question';
  function changes(t, prev) {
    const out = {move: {}, isNew: new Set(), dropped: []};
    if (!prev) return out;
    const before = new Map(ranked(prev.table).map(r => [r.key, r.rank]));
    const now = new Map(ranked(t.table).map(r => [r.key, r.rank]));
    now.forEach((rank, key) => { if (!before.has(key)) out.isNew.add(key); else out.move[key] = before.get(key) - rank; });
    const prevAsked = askedSet(prev), waitingNow = new Set(t.table.filter(r => !r.rank).map(r => r.key));
    ranked(prev.table).filter(r => !now.has(r.key)).forEach(r =>
      out.dropped.push({row: r, why: prevAsked.has(r.key) ? DROP_ANSWERED : waitingNow.has(r.key) ? DROP_WAITING : DROP_GONE}));
    return out;
  }
  function summary(t, d) {
    const rows = ranked(t.table), asked = askedSet(t);
    const picked = rows.filter(r => asked.has(r.key)), rest = rows.filter(r => !asked.has(r.key));
    const open = t.open ? ' ' + d.plural(t.open, 'open cause') + '.' : '';
    if (!picked.length) return 'Turn ' + t.n + ': no question from this table was asked; a check of a possible cause ran instead.' + open;
    const top = picked[0], next = rest[0];
    const more = picked.length > 1 ? ' and ' + (picked.length - 1) + ' more' : '';
    const gap = next ? ', ' + d.num2(Number(top.likelihood) - Number(next.likelihood)) + ' above the next question' : ', the only question left that tells the causes apart';
    return 'Turn ' + t.n + ': asked ' + label(top, d) + more + ' because it scored ' + d.num2(top.likelihood) + gap + '.' + open;
  }
  function changeList(t, prev, ch, d) {
    if (!prev) return d.muted('First turn shown: nothing to compare with yet.');
    const items = [];
    ranked(t.table).forEach(r => {
      const m = ch.move[r.key];
      if (ch.isNew.has(r.key)) items.push(['v4-up', 'New: ' + label(r, d) + ' (unlocked by an answer, now #' + r.rank + ')']);
      else if (m) items.push([m > 0 ? 'v4-up' : 'v4-down', (m > 0 ? '▲ ' : '▼ ') + label(r, d) + ' moved ' + (m > 0 ? 'up ' : 'down ') + Math.abs(m) + ' to #' + r.rank]);
    });
    ch.dropped.forEach(x => items.push(['v4-muted', label(x.row, d) + ': ' + x.why]));
    if (t.open !== prev.open && t.open && prev.open) items.push(['', 'Open causes: ' + prev.open + ' → ' + t.open]);
    if (!items.length) return d.muted('Same order as turn ' + prev.n + '.');
    return d.h('ul', {class: 'v4-qt-changes'}, items.map(([cls, text]) => d.h('li', {class: cls}, text)));
  }

  // ---------- the turn selector (tabs) ----------
  function pick(n, d, moveFocus) {
    selected = n === hist[hist.length - 1].n ? null : n;
    focusAfter = !!moveFocus;
    d.rerender();
  }
  function selector(cur, d) {
    const live = hist[hist.length - 1].n;
    const list = d.h('div', {class: 'v4-qt-turns', role: 'tablist', 'aria-label': 'Turns'}, hist.map(t => {
      const on = t.n === cur.n;
      return d.h('button', {type: 'button', role: 'tab', id: TAB_PREFIX + t.n, class: 'v4-qt-chip' + (on ? ' on' : ''), 'aria-selected': String(on),
        'aria-controls': PANEL_ID, tabindex: on ? '0' : '-1', onclick: () => pick(t.n, d, false)}, 'Turn ' + t.n, t.n === live ? d.h('span', {class: 'v4-qt-live'}, 'live') : null);
    }));
    list.addEventListener('keydown', e => {
      const i = hist.findIndex(t => t.n === cur.n);
      const j = {ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: hist.length - 1}[e.key];
      if (j === undefined || j < 0 || j >= hist.length) return;
      e.preventDefault(); pick(hist[j].n, d, true);
    });
    if (focusAfter) { focusAfter = false; requestAnimationFrame(() => { const b = document.getElementById(TAB_PREFIX + cur.n); if (b) b.focus(); }); }
    return list;
  }

  // ---------- the table of one turn ----------
  function table(t, ch, isLive, d) {
    if (t.v5 && !t.v5.scored) return [d.muted('No question was scored in this turn (a check of a possible cause ran).')];
    const rows = ranked(t.table), asked = askedSet(t), flash = isLive && t.n !== flashed && t.n > 1;
    const shown = showAll ? rows : rows.slice(0, d.rows);
    const head = ['#', 'Question', 'Guide × K1', 'Past conversations × K2', 'Score', 'Since last turn', 'Rank without past conversations'];
    const rowFor = r => {
      const on = asked.has(r.key), m = ch.move[r.key], fresh = ch.isNew.has(r.key);
      const since = fresh ? 'new' : m > 0 ? '▲ ' + m : m < 0 ? '▼ ' + -m : '·';
      const was = r.rank_cold && r.rank_cold !== r.rank ? (r.rank_cold > r.rank ? '▲ was #' : '▼ was #') + r.rank_cold : (r.rank_cold ? 'same' : '·');
      const cls = [on ? 'v4-asking' : '', flash && (fresh || m) ? FLASH_CLASS : ''].filter(Boolean).join(' ');
      return d.h('tr', {class: cls || null},
        d.h('td', {class: 'v4-n'}, String(r.rank)),
        d.h('th', {scope: 'row', class: 'v4-rowh', title: d.originText[r.origin] || ''}, label(r, d), on ? d.h('span', {class: 'v4-tag'}, isLive ? 'Asked now' : 'Asked') : null),
        d.h('td', {title: 'Guide = ' + d.num2(r.confidence) + ' (linked to ' + r.reach + ' of ' + r.n_open + ' open causes)'}, d.num2(r.k1_part)),
        d.h('td', {title: 'Past conversations = ' + d.num2(r.usage) + (t.taught ? ' (from ' + d.num2(r.cases_seen) + ' conversation-weights)' : ' (no past conversations yet)')}, d.num2(r.k2_part)),
        d.scoreCell(r),
        d.h('td', {class: fresh || m ? (fresh || m > 0 ? 'v4-up' : 'v4-down') : 'v4-muted'}, since),
        d.h('td', {class: 'v4-muted'}, was));
    };
    if (flash) flashed = t.n;
    const waiting = t.table.filter(r => !r.rank);
    return [
      d.h('div', {class: 'v4-legend'}, d.h('i', {class: 'v4-sbar-guide'}), ' from the guide   ', d.h('i', {class: 'v4-sbar-past'}), ' from past conversations'),
      d.h('div', {class: 'v4-scroll'}, d.h('table', {class: 'v4-matrix v4-order'},
        d.h('thead', null, d.h('tr', null, head.map((x, i) => d.h('th', {scope: 'col', class: i === 1 ? 'v4-rowh' : ''}, x)))),
        d.h('tbody', null, shown.map(rowFor)))),
      rows.length > d.rows ? d.h('button', {type: 'button', class: 'v4-small', onclick: () => { showAll = !showAll; d.rerender(); }}, showAll ? 'Show fewer' : 'Show all ' + rows.length) : null,
      waiting.length ? d.muted(d.plural(waiting.length, 'more question') + ' will be considered after an earlier answer.') : null,
      t.taught === 0 ? d.muted('No past conversations yet for these causes, so the score comes from the guide only.')
        : d.muted(d.plural(t.taught, 'past conversation') + ' counted. The last column shows where each question would rank without them.'),
      t.k1 === 0 && t.k2 === 0 ? d.muted('K1 and K2 are both 0, so every question scores 0. Raise one of them in Details.') : null,
    ];
  }

  function render(d) {
    if (!hist.length) return null;
    const live = hist[hist.length - 1];
    const cur = (selected !== null && hist.find(t => t.n === selected)) || live;
    if (cur === live) selected = null;
    const isLive = cur === live, i = hist.indexOf(cur), prev = i > 0 ? hist[i - 1] : null, ch = changes(cur, prev);
    const formula = d.h('div', {class: 'v4-qt-formula'}, d.h('span', {class: 'v4-formula'}, 'Score = K1 × Guide + K2 × Past conversations'),
      d.h('span', {class: 'v4-muted'}, ' K1 ' + d.num2(cur.k1) + ' · K2 ' + d.num2(cur.k2)));
    const panel = d.h('div', {class: 'v4-qt-panel', id: PANEL_ID, role: 'tabpanel', 'aria-labelledby': TAB_PREFIX + cur.n, tabindex: '0'},
      d.h('p', {class: 'v4-qt-summary', 'aria-live': isLive ? 'polite' : null}, summary(cur, d)),
      isLive ? null : d.muted('Read-only view of turn ' + cur.n + '. Pick the live turn to see the questions now.'),
      turnBreakdown(cur, d),
      d.h('div', {class: 'v4-label'}, 'Question scores (composite matrix)'), ...table(cur, ch, isLive, d),
      d.h('div', {class: 'v4-label'}, 'What changed since the turn before'), changeList(cur, prev, ch, d));
    return d.h('div', {class: 'v4-qscore'}, formula,
      // V5: folded by default so the turn breakdown and the matrix sit near the top of the compact popover
      d.section('order-formula', 'How the score works', d.formulaCard(cur.k1, cur.k2, ranked(cur.table)[0]), {cls: 'v4-mini', open: !cur.v5}),
      d.section('order-ramp', 'How past conversations grow', d.k2Ramp(cur.k2), {cls: 'v4-mini', open: !cur.v5}),
      selector(cur, d), panel);
  }

  window.Rhs4QTurns = {record, reset, has, render, load};
})();
